import { IconDefinition } from "@fortawesome/pro-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { GridActionsCellItem } from "@mui/x-data-grid-premium";
import React, { memo } from "react";
import { CircularProgress } from "@mui/material";

interface ActionCellItemProps {
    onClick: (event: React.MouseEvent) => void;
    icon: IconDefinition;
    color: string;
    label: string;
    disabled?: boolean;
    loading?: boolean;
}

const ActionCellItem: React.FC<ActionCellItemProps> = memo(({ onClick, color, icon, label, disabled = false, loading = false }) => {
    return (
        <GridActionsCellItem
            icon={loading ? <CircularProgress size={16} /> : <FontAwesomeIcon icon={icon} color={color} />}
            label={label}
            onClick={onClick}
            disabled={disabled || loading}
        />
    );
});

export default ActionCellItem;
